var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"split-ellipsis"},[_c('span',{staticClass:"split-ellipsis__head text-truncate"},[_vm._v(_vm._s(_vm.head))]),(_vm.tail)?_c('span',{staticClass:"split-ellipsis__tail"},[_vm._v(_vm._s(_vm.tail))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }